import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=1f9ac31c&scoped=true"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=1f9ac31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9ac31c",
  null
  
)

export default component.exports